import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { LoginService } from 'src/app/Common/Services/login.service';
import { ToastrService } from 'ngx-toastr';
import { HttpHeaders } from '@angular/common/http';
import { match } from 'minimatch';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

export interface menugroup {
  value: string;
  viewValue: string;
}

export interface product{
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-usercreationedit',
  templateUrl: './usercreationedit.component.html',
  styleUrls: ['./usercreationedit.component.css']
})


export class UsercreationeditComponent implements OnInit {
  ischecked =false;
  isDisabled:boolean = false;
  menugroups: menugroup[] = [
    {value: 'AGN', viewValue: 'Agent'},
    {value: 'CSR', viewValue: 'CSR'}
  ];

  products:product[]=[
    {value: '7021', viewValue: 'Motor Insurance'},
    {value: '8080', viewValue: 'Property Insurance'},
    {value: '1017', viewValue: 'General Accident'},
    {value: '6070', viewValue: 'Travel Insurance'}
  ];

  usercreateform :FormGroup;
  username:any;
  flowMode:any;
  validFlag:any;
  productList :any[]=[];
  unselectlist:any[]=[];  
  val:any;
  sysId:any;
  minDate:any;
  editproduct:any[]=[];
  mode:any;
  constructor(public dialog: MatDialog,private _formbuilder: FormBuilder,public loginservice:LoginService,private toastr: ToastrService, public router:Router,private route: ActivatedRoute) {
    
    this.usercreateform=this._formbuilder.group({
     username:['',[Validators.required,Validators.minLength(8),Validators.maxLength(16),Validators.pattern('^[a-zA-Z0-9]+$')]],
     password:['',[Validators.required]],
     name:['',[Validators.required]],
     emailid:['',[Validators.required,Validators.email]],
     suminsured:['',[Validators.pattern('^(0|[0-9][0-9]*)$')]],
     mobileno:['',[Validators.required,Validators.minLength(8),Validators.pattern('^(0|[0-9][0-9]*)$')]],
     premiumlimit:['',[Validators.pattern('^(0|[0-9][0-9]*)$')]],
     product:[''],
     expirydate:['',[Validators.required]],
     Status:['',[Validators.required]],
     menugroup:['',[Validators.required]]
    })


    this.usercreateform.get("password").valueChanges.subscribe(res=>{
      if(res.length != 0){
        this.isDisabled = true
      }else{
        this.isDisabled = false;
      }

    })

  }


  ngOnInit() {
    
    var agentId =sessionStorage.getItem('agentId');
    var agentname = sessionStorage.getItem('agentname');
  // For EDIT Mode
     this.route.queryParams.subscribe(params => {
      this.username = params["username"];     
      this.flowMode = params["flowMode"];  
    });
    if(this.flowMode!=undefined && this.flowMode!=null && this.flowMode!="" && this.flowMode=="EDIT"){
    
    this.loginservice.editUserDetails(this.username).subscribe((data:any)=>{
    if(data.responseBody.userDetail != null){
    
    let username =this.username;
    let password = data.responseBody.userDetail["0"].password;
    let name = data.responseBody.userDetail["0"].name;
    let emailid =data.responseBody.userDetail["0"].emailid;
    let mobileno = data.responseBody.userDetail["0"].mobileno;
    let suminsured = data.responseBody.userDetail["0"].suminsured;
    let premiumlimit =data.responseBody.userDetail["0"].premiumlimit;
    let Status = data.responseBody.userDetail["0"].status;
    let menugroup = data.responseBody.userDetail["0"].usertype;
     //to set date
     var from = data.responseBody.userDetail["0"].validupto; // OR $("#datepicker").val();
     var milliseconds = moment(from, "DD-MM-YYYY").format();
     var dob = new Date(milliseconds);
     var product = data.responseBody.userDetail["0"].product;
     this.sysId=data.responseBody.userDetail["0"].sysId;
     if(product !="7021" || product !="6070" || product !="8080" || product !="1017"){
     this.editproduct = product.split(',');
     this.productList =this.editproduct;
    
    for(let i=0;i<this.productList.length;i++){
      if(this.productList[i]=="7021"){
        (<HTMLInputElement>document.getElementById('check1')).checked = true;
      }if(this.productList[i]=="8080"){
        (<HTMLInputElement>document.getElementById('check2')).checked = true;
      }if(this.productList[i]=="1017"){
        (<HTMLInputElement>document.getElementById('check3')).checked = true;
      }if(this.productList[i]=="6070"){
        (<HTMLInputElement>document.getElementById('check4')).checked = true;
      }
    }
  }else{
  //to make the product checked based on the list of product selected by the user
  if(product=="7021"){
    (<HTMLInputElement>document.getElementById('check1')).checked = true;
  }if(product=="8080"){
    (<HTMLInputElement>document.getElementById('check2')).checked = true;
  }if(product=="1017"){
    (<HTMLInputElement>document.getElementById('check3')).checked = true;
  }if(product=="6070"){
    (<HTMLInputElement>document.getElementById('check4')).checked = true;
  }
  }
  //end

    this.usercreateform.patchValue({
      username:username,
      password:password,
      name:name,
      emailid:emailid,
      mobileno : mobileno,
      suminsured:suminsured,
      premiumlimit:premiumlimit,
      Status :Status,
      menugroup:menugroup,
      expirydate:new Date (dob),
    });

    
   
    (<HTMLInputElement>document.getElementById("username")).disabled = true;
    }
    });
  }
    }

    onCheckChange($event){
      
      if($event.target.checked ==true){
        this.val= $event.target.value;
        this.productList.push(this.val);  
       console.log("Product List", this.productList);
      }else{
        this.val= $event.target.value;
        for(let i=0; i< this.productList.length; i++){
        if(this.productList[i] == this.val){
          var index = i;
          this.productList.splice(index, 1);  
          console.log("product List", this.productList);
        }
      }  
      }
    
    }
   
  submit(usercreateform){
    
    if(this.flowMode=="EDIT"){
      this.validFlag=true;
    }
    if(!this.usercreateform.invalid && this.validFlag){
      if(this.flowMode=="EDIT"){
      var productlist =this.productList;
      this.usercreateform.value.mode = this.flowMode;
      this.usercreateform.value.id=this.sysId;
      let Form = JSON.stringify(this.usercreateform.value);
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/json');
      this.loginservice.usercreationedit(Form,productlist).subscribe((res: any)=>{
        console.log(res);
        
        if(res.responseBody.validationMsg){
          this.toastr.success(res.responseBody.validationMsg, undefined, {
            positionClass: 'toast-bottom-right',
            timeOut: 6000
       });
        }
      })
      }
      this.dialog.closeAll();
    } 
    if(this.flowMode == undefined){
    if(this.usercreateform.valid){
      usercreateform.value.agentId =sessionStorage.getItem('agentId');
      usercreateform.value.agentname =sessionStorage.getItem('agentname');
      var productlist =this.productList;
      let Form = JSON.stringify(this.usercreateform.value);
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/json');
      this.loginservice.usercreation(Form,productlist).subscribe((res: any)=>{
        console.log(res);
        
        if(res.responseBody.validationMsg != undefined){
           var username = this.usercreateform.value.username;
          this.loginservice.usercreationSMS(username).subscribe((res: any)=>{
          this.toastr.success(res.responseBody.validationMsg, undefined, {
            positionClass: 'toast-bottom-right',
            timeOut: 6000
       });
      })
        }

      })
      this.dialog.closeAll();
  }

  }
  }

  onStrengthChanged(eve){
    
    if(eve == 100){
     this.isDisabled = false;
    }
  }

    Clear(){
    
    this.usercreateform.reset();
  }

  usernameChange(){
    
  var username=this.usercreateform.get('username').value;
  this.loginservice.useridValidation(username).subscribe((res:any)=>{
  if(res.responseBody.validationMsg == null){
  
  }
  else{
     
    this.usercreateform.patchValue({  
      username:""
    });
    this.toastr.error(res.responseBody.validationMsg, undefined, {
      positionClass: 'toast-bottom-right',
      timeOut: 6000
 });

  }
    })
  }

  //for email id duplicate validation

  emailidChange(){
    
    var emailid=this.usercreateform.get('emailid').value;
  this.loginservice.emailidValidation(emailid).subscribe((res:any)=>{
    
  if(res.responseBody.validationMsg == null){
  }
  else{
     
    this.usercreateform.patchValue({  
      emailid:""
    });
    this.toastr.error(res.responseBody.validationMsg, undefined, {
      positionClass: 'toast-bottom-right',
      timeOut: 6000
 });

  }
})
  }

  mobileChange(){
    
    var str = this.usercreateform.value.mobileno.slice(0, 1);
    if(str !== "5"){
      this.usercreateform.patchValue({  
        mobileno:""
      });
      this.toastr.error("Mobile number should start with number 5", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
   });
    }
    else if(this.usercreateform.value.mobileno == "" || this.usercreateform.value.mobileno == undefined) {
      this.usercreateform.patchValue({  
        mobileno:""
      });
      this.toastr.error("Please Enter MobileNo", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
   });
     }
  }
  

  expirydatechange(type: string, event){
    
  var dob=this.usercreateform.value.expirydate;
  var currentdate = new Date(); 

  if(dob > currentdate || dob == currentdate){
  }else{
    this.toastr.error("Expiry date should not be less than the current date", undefined, {
            positionClass: 'toast-bottom-right',
            timeOut: 6000
       });
       this.usercreateform.patchValue({
         expirydate:''
       })
  }
  
  }
  

}
